<template>
  <modal v-model="openModel" :max-width="550">
    <template #title>Stopping Criteria Reached</template>
    <template #content>
      <p>
        The stopping criteria has been met, indicating that it is
        unlikely there are any more relevant documents remaining.
      </p>
      <p>The following conditions were met:</p>
      <ul class="mb-2">
        <li>
          the estimated number of remaining Relevant references is
          zero, and;
        </li>
        <li>
          the last 40 screened were determined to be Not Relevant.
        </li>
      </ul>
      <p v-if="allowExcludeRemaining">
        Would you like to mark the remaining documents as
        <span class="font-weight-bold">Not Relevant</span>?
      </p>
      <p v-else>
        Please inform your lead reviewer that they may exclude the
        remaining references, if desired.
      </p>
    </template>
    <template #actions>
      <action-button @click="openModel = false">
        {{ allowExcludeRemaining ? 'Cancel' : 'Close' }}
      </action-button>
      <template v-if="allowExcludeRemaining">
        <action-button
          class="ml-3"
          color="error"
          @click="$emit('exclude-remaining')"
        >
          Exclude Remaining
        </action-button>
      </template>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';

export default {
  name: 'StopScreeningModal',
  components: {
    ActionButton,
    Modal,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    allowExcludeRemaining: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open', 'exclude-remaining'],
  computed: {
    openModel: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
  },
};
</script>
